import { useAuth0 } from '@auth0/auth0-react';
import Header from 'components/Common/Header';
import Login from 'components/Login';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { GuardedRoute, GuardProvider } from 'react-router-guards';
import CustomQuotes from './containers/CustomQuotes';
import OperationsPage from './containers/OperationsPage';
import ProductPage from './containers/ProductPage';
import ProposalCenterPage from './containers/ProposalCenterPage';
import ReportsPage from './containers/ReportsPage';
import RubiYieldProductPage from './containers/RubiYieldProductPage';
import UnwindingPage from './V2/pages/UnwindingPage';

const Routes = () => {
  const { isAuthenticated, user: userAuth0, isLoading } = useAuth0();

  const requireLogin = async (to, from, next) => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated) {
      next();
    } else {
      next.redirect('/login');
    }
  };

  if (isLoading) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      {isAuthenticated && <Header userName={userAuth0?.name || userAuth0?.email} />}

      <Switch onUpdate={() => window.scrollTo(0, 0)}>
        <Route path="/login" exact component={Login} />
        <GuardProvider guards={[requireLogin]}>
          <GuardedRoute exact path="/" render={() => <Redirect to="/operacoes" />} />
          <GuardedRoute path="/relatorios" component={ReportsPage} />
          <GuardedRoute path="/operacoes" component={OperationsPage} />
          <GuardedRoute
            path="/antecipacao/:codOperacao?"
            component={UnwindingPage}
          />
          <GuardedRoute
            path="/operacao/novasoperacoes/:id"
            name="Detalhe da operação"
            component={RubiYieldProductPage}
          />
          <GuardedRoute
            path="/operacao/:id/:debugMode"
            name="Detalhe da operação"
            component={ProductPage}
          />
          <GuardedRoute
            path="/operacao/:id"
            name="Detalhe da operação"
            component={ProductPage}
          />
          <GuardedRoute
            path="/central-de-propostas"
            component={ProposalCenterPage}
          />
          <GuardedRoute
            path="/cotacoes-personalizadas"
            component={CustomQuotes}
          />
          <Redirect from="/id_token=*" to="/" />
        </GuardProvider>
      </Switch>
    </>
  );
};


export default Routes;
